import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './App.vue';
import router from './router';

import AuthService from './services/Auth';
import KrakenService from './services/Kraken';
import ConfigService from './services/Config';
import HttpService from './services/Http';

Vue.config.productionTip = false;

Vue.mixin(ConfigService);
Vue.mixin(HttpService);

Sentry.init({
  dsn: 'https://c2784a05cd5c44118fab3b992e1ad7d8@sentry.io/1251637',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

new Vue({
  mixins: [AuthService, KrakenService],
  router,
  render: h => h(App)
}).$mount('#app');
